import { createContext } from "react";

export const RoomContext = createContext(null);
